<template>
  <MyPeriodicidade
    v-if="show_periodicidade_loc"
    :data="period_data"
    @save="set_dados_periodicidade_loc"
    @close="show_periodicidade_loc = false"
  />
  <AppTablePagination
    :visibility="true"
    :show="true"
    :AddRemoveBtn="{
      //   verDefault:true,
      verAdicionar: true,
      verRetirar: true,
    }"
    :filterBtn="true"
    :table_title="'Periodicidades Padrões'"
    :data="filter_data"
    @open-adicionar="create_periodicidade_loc"
    @open-retirar="openConfirm"
    @open-default="null"
    @open-filter="showPeriodicidadeFilter = true"
    @row-clicked="select_periodicidade_loc"
    @close="null"
    :hidden-columns="[
      'id',
      'familia_id',
      'tpservico_id',
      'tpprox_id',
      'localInstalacao_id',
    ]"
    :urlString="urlString"
    :refresh="refresh_periodicidade_table"
    @refreshed="refresh_periodicidade_table = false"
  />
   <PeriodicidadeFilter v-if="showPeriodicidadeFilter" :data="filter_data" @save="set_filter"
      @close="showPeriodicidadeFilter = false" />
  <Confirm
    v-if="show_confirm"
    :message="confirmMessage"
    @confirm="delete_periodicidade"
    @cancel="show_confirm = false"
  />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import axios from "axios";
import { toast } from "vue3-toastify";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";
import MyPeriodicidade from "@/components/popUps/myPeriodicidade.vue";
import Confirm from "@/components/simpleConfirmComponent.vue";
import PeriodicidadeFilter from "@/components/popUps/periodicidadeFilter.vue";

const baseURl = process.env.VUE_APP_URL_BASE;
const refresh_periodicidade_table = ref(false);
const show_confirm = ref(false);
const urlString = ref("periodicidade/tablefilter");
const filter_data = ref({
  nome: "",
  tempo: "",
  familia: [],
  servico_a: [],
  servico_b: [],
  fields: "id,tempo,servico,proximo,familia"
});
const showPeriodicidadeFilter = ref(false);
const confirmMessage = computed(() => {
  return "Tem certeza que deseja excluir esta periodicidade?";
});

const show_periodicidade_loc = ref(false);
const period_data = ref({
  id: 0,
  tempo: 365,
  servico_a: { id: 0, nome: "" },
  servico_b: { id: 0, nome: "" },
  familia: { id: 0, nome: "" },
});


function set_filter(data) {
  console.log('Filter data received:', data);
  // Update the URL to use tablefilter endpoint for periodicidade
  urlString.value = "periodicidade/tablefilter";
  // Store filter data as a deep copy
  filter_data.value = JSON.parse(JSON.stringify(data));
  // Close the filter modal
  showPeriodicidadeFilter.value = false;
  // Refresh the table with new filters
  refresh_periodicidade_table.value = true;
}

function create_periodicidade_loc(data) {
  period_data.value = {
    id: 0,
    tempo: 365,
    servico_a: { id: 0, nome: "" },
    servico_b: { id: 0, nome: "" },
    familia: { id: 0, nome: "" },
  };
  show_periodicidade_loc.value = true;
}

function select_periodicidade_loc(data) {
  period_data.value = {
    id: data.id,
    localInstalacao_id: data.localInstalacao_id,
    tempo: data.Periodicidade,
    servico_a: {
      id: data.tpservico_id,
      nome: data.servico,
    },
    servico_b: {
      id: data.tpprox_id,
      nome: data.proximo,
    },
    familia: {
      id: data.familia_id,
      nome: data.familia,
    },
  };
  show_periodicidade_loc.value = true;
}
function openConfirm() {
  if (period_data.value.id === 0) {
    toast.error("Selecione uma periodicidade para excluir.", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 3000,
    });
    return;
  }

  show_confirm.value = true;
}

// ✅ Updated function with proper create/update logic
async function set_dados_periodicidade_loc(data) {
  show_periodicidade_loc.value = false;

  const payload = {
    id: data.id,
    localInstalacao_id: 0,
    familia_id: data.familia.id,
    familia_nome: data.familia.nome,
    Periodicidade: data.tempo,
    tpservico_id: data.servico_a.id,
    tpservico_nome: data.servico_a.nome,
    tpprox_id: data.servico_b.id,
    tpprox_nome: data.servico_b.nome,
  };

  try {
    let res;

    // ✅ Check if it's an update (has ID) or create (no ID)
    if (data.id && data.id > 0) {
      // ✅ UPDATE: Use PUT method with proper endpoint
      res = await axios.put(
        `${baseURl}/api/v1/periodicidade/editar/${data.id}/`,
        payload
      );

      toast.success("Periodicidade atualizada com sucesso", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
      });
    } else {
      // ✅ CREATE: Use POST method
      res = await axios.post(
        `${baseURl}/api/v1/periodicidade/registrar/`,
        payload
      );

      toast.success("Periodicidade criada com sucesso", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
      });
    }

    // ✅ Refresh table after successful operation
    if (res && res.status >= 200 && res.status < 300) {
      refresh_periodicidade_table.value = true;
    }
  } catch (error) {
    console.error("Erro ao salvar periodicidade:", error);

    const operation = data.id && data.id > 0 ? "atualizar" : "criar";
    toast.error(
      `Erro ao ${operation} periodicidade: ${
        error.response?.data?.error || error.message
      }`,
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      }
    );
  }
}

async function delete_periodicidade() {
  show_confirm.value = false;

  try {
    await axios.delete(
      `${baseURl}/api/v1/periodicidade/eliminar/${period_data.value.id}/`
    );
    toast.success("Periodicidade apagada com sucesso!", {
      position: "top-center",
      autoClose: 1000,
    });
    refresh_periodicidade_table.value = true;
  } catch (error) {
    console.error("Erro ao apagar periodicidade:", error);
    toast.error(
      `Erro ao apagar periodicidade: ${
        error.response?.data?.error || error.message
      }`,
      {
        position: "top-center",
        autoClose: 3000,
      }
    );
  }
}

// Initialize filter data on component mount
onMounted(() => {
  filter_data.value = {
    nome: "",
    tempo: "",
    familia: [],
    servico_a: [],
    servico_b: [],
    fields: "id,tempo,servico,proximo,familia"
  };
});
</script>
